// extracted by mini-css-extract-plugin
export default {"mockup":"style_mockup__fUwKR","blue-wave":"style_blue-wave__KtcME","wave":"style_wave__NUi-q"};